import {
  baseRefreshToken,
  baseAPIinstance,
  addAuthorization,
  ACCESS_TOKEN,
} from './BaseRefreshHelper';
import Cookies from 'cookies-js';
const GET_BRANDS_PATH = '/graphql';

class APIHelper {
  constructor() {
    const token = Cookies.get(ACCESS_TOKEN);
    addAuthorization(token);
    baseRefreshToken();
  }
  callGraphQLAPI = (payload) => {
    const { query, variables } = payload;
    const graphQL = {
      query: query,
      variables: variables,
    };
    const apiResponse = baseAPIinstance
      .post(GET_BRANDS_PATH, JSON.stringify(graphQL))
      .catch((error) => error.response);
    return apiResponse;
  };

  callUpLoadFile = (path, body) => {
    console.log('uploadImageCall', path, body);
    const apiResponse = baseAPIinstance
      .post(path, body, {
        headers: { 'Content-Type': '*/*', Accept: '*/*' },
      })
      .catch((error) => error.response);
    console.log('uploadImageCall', apiResponse);
    return apiResponse;
  };
}

export const BaseHelper = new APIHelper();
